import React, { useState } from "react";
import Footer from "./Footer";
import { CiCircleChevDown, CiCircleChevUp } from "react-icons/ci";
import { MdPictureAsPdf } from "react-icons/md";
import GetInTouchFooter from "./GetInTouchFooter";
import { Helmet } from "react-helmet";
import glance1 from "../assets/glance-1.pdf";
import glance2 from "../assets/glance-2.pdf";
import glance3 from "../assets/glance-3.pdf";
import glance4 from "../assets/glance-4.pdf";


const julyDownloads = [glance1, glance4, glance3, glance2];

const MonthAtAGlance = () => {
  const [expanded2021, setExpanded2021] = useState(true);
  const [expanded2020, setExpanded2020] = useState(false);
  window.scrollTo(0, 20);
  const styles = {
    container: {
      backgroundColor: "#f9fafb",
      padding: "0px 7%",
    },
    subtitle: {
      fontSize: "18px",
      color: "#6b7280",
      marginBottom: "16px",
      textAlign: "center",
    },
    section: {
      marginBottom: "24px",
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      backgroundColor: "white",
      overflow: "hidden",
    },
    header: {
      backgroundColor: "#ffffff",
      color: "#D31C4F",
      padding: "12px",
      fontWeight: "bold",
      fontSize: "18px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
    },
    expandicon_div: {
      color: "#D31C4F",
      padding: "12px",
      fontWeight: "bold",
      fontSize: "18px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      borderRadius: "12px !important",
    },
    tableHeader: {
      backgroundColor: "#FFDBE5",
    },
    tableCell: {
      padding: "12px",
      fontSize: "17px",
      border: "1px solid #e5e7eb",
      textAlign: "center",
    },
    downloadLink: {
      display: "inline-flex",
      alignItems: "center",
      color: "#D31C4F",
      textDecoration: "none",
      fontWeight: "bold",
      cursor: "pointer",
    },
    downloadIcon: {
      marginRight: "8px",
    },
  };

  const months = ["April", "July", "August", "September"];
  const columns = ["PG", "PN", "Nursery", "Prep"];

  const renderTable = () => (
    <table style={styles.table}>
      <thead style={styles.tableHeader}>
        <tr>
          <th style={styles.tableCell}>Month</th>
          {columns.map((col, index) => (
            <th key={index} style={styles.tableCell}>
              {col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {months.map((month, index) => (
          <tr
            key={index}
            style={index % 2 === 0 ? { backgroundColor: "#f9fafb" } : {}}
          >
            <td style={styles.tableCell}>{month}</td>
            {columns.map((col, index) => (
              <td key={index} style={styles.tableCell}>
                {month !== "July" ? (
                  <div className="text-gray-400 font-semibold">Upcoming</div>
                ) : (
                  <a href={julyDownloads[index]} download={`glance${col}.pdf`} style={styles.downloadLink}>
                    <span style={styles.downloadIcon}>
                      <MdPictureAsPdf />
                    </span>{" "}
                    Download
                  </a>
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <div>
      <Helmet>
        <title>
          Monthly Calendar at Mother's Pride - Stay Updated on School Life
        </title>
        <meta
          name="description"
          content="Check the monthly calendar of Mother's Pride to stay informed about upcoming events, holidays, and learning activities at the preschool."
        />
        <meta name="keywords" content="" />
        <link
          rel="canonical"
          href="https://www.motherspridepreschool.com/monthcal"/>
      </Helmet>
      <div style={styles.container} className=" font-Lato h-[calc(100vh-80px)]">
        <h1 className="text-[30px] sm:text-[60px] pt-10 font-Wonderbar">
          Month at a{" "}
          <span style={{ color: "#D31C4F" }}>
            Glance <img className="inline h-[36px]" alt="" />{" "}
          </span>
        </h1>
        <div
          style={{
            marginBottom: "24px",
            borderTop: !expanded2021 && "1px solid #949494",
            borderBottom: !expanded2021 && "1px solid #949494",
          }}
        >
          <div
            style={styles.expandicon_div}
            onClick={() => setExpanded2021(!expanded2021)}
          >
            YEAR 2025
            <span className="text-[40px] text-black">
              {expanded2021 ? <CiCircleChevUp /> : <CiCircleChevDown />}
            </span>
          </div>
          <div className="overflow-x-scroll scrollbar-hidden">
            {expanded2021 && renderTable()}
          </div>
        </div>
        <GetInTouchFooter marginX={"0%"} />
        <div className=" h-[20%] lg:h-[24%]">
          <Footer marginX={"0%"} />
        </div>
      </div>
    </div>
  );
};

export default MonthAtAGlance;
